import { render } from "./NewPartner.vue?vue&type=template&id=60741f68&scoped=true"
import script from "./NewPartner.vue?vue&type=script&lang=js"
export * from "./NewPartner.vue?vue&type=script&lang=js"

import "./NewPartner.vue?vue&type=style&index=0&id=60741f68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60741f68"]])

export default __exports__